import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || '';

// Public API calls
export const publicAPI = {
  // Services
  getServices: async (language = 'RU', category = null) => {
    try {
      const params = { language };
      if (category) params.category = category;
      
      const response = await axios.get(`${API_BASE_URL}/api/services`, { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching services:', error);
      throw error;
    }
  },

  getServiceBySlug: async (slug, language = 'RU') => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/services/${slug}`, {
        params: { language }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching service:', error);
      throw error;
    }
  },

  // Pages
  getAllPages: async (language = 'RU') => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/pages`, {
        params: { language }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching pages:', error);
      throw error;
    }
  },

  getPageContent: async (pageKey, language = 'RU') => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/pages/${pageKey}`, {
        params: { language }
      });
      return response.data.content;
    } catch (error) {
      console.error('Error fetching page content:', error);
      throw error;
    }
  },

  // Inquiries
  submitInquiry: async (formData) => {
    try {
      const response = await axios.post(`${API_BASE_URL}/api/inquiries`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error submitting inquiry:', error);
      throw error;
    }
  },

  // Health check
  healthCheck: async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/health`);
      return response.data;
    } catch (error) {
      console.error('Error checking health:', error);
      throw error;
    }
  }
};

export default publicAPI;
